module.exports = __webpack_public_path__ + "img/radiometer-logo1.73b5b9e0.png";